import { createReducer } from '@reduxjs/toolkit';
import omit from 'lodash/omit';
import reduce from 'lodash/reduce';

import { ActionClearType, INITIALIZE_CUSTOM_PAGE_DATA } from 'constants/redux-actions';

const initState = {
  contentBlocks: [],
  contents: [],
};

const reduceContents = (contents, initData) =>
  reduce(
    contents,
    (res, content) => (content.visible ? { ...res, [content.key]: content } : omit(res, [content.key])),
    initData,
  );

const customPageReducer = createReducer(initState, {
  [INITIALIZE_CUSTOM_PAGE_DATA]: (state, { payload }) => {
    const contents = reduceContents(payload.contents, state.contents);

    return { ...state, ...payload, contents };
  },
  [ActionClearType(INITIALIZE_CUSTOM_PAGE_DATA)]: () => initState,
});

export default customPageReducer;
